import React from 'react'
import { Grid, Icon } from 'semantic-ui-react'
import InputField from '../../../../commonComponents/formComponents/inputField'
import DropDown from '../../../../commonComponents/formComponents/dropDown'
import { useDispatch, useSelector } from 'react-redux'
import { TranslateContext } from '../../TranslateContext'
import { AddDropdown } from '../../../../commonComponents/dropdown/AddDropdown'
import validate from 'validate.js'
import * as ActionTypes from '../../../actions/actionTypes'

import { createRepElemMsgStructure } from '../../../util/itemsTabValidation'
import CopyRepElement from '../../../../GB_App/formSections/itemsTab/copyRepElement'

const AdditionalDocumentDetailsAGS = ({
  item: { documentCode, ref, amount, uom, currency, quantity, id },
  deleteData,
  updateData,
  saveData,
  copyData,
  isFormdisabled,
  invoiceIndex,
  lineItemIndex,
  addDocIdx,
  fieldPattern,
  validateError,
  initItemsTabValidation
}) => {

  const dispatch = useDispatch()
  const translate = React.useContext(TranslateContext).translate
  const currencyList = useSelector((state) => state.DropDownValues?.currencyCodes) || []
  const UomDropdownValue = useSelector((state) => state.DropDownValues?.UoM) || []

  const { additionalDoc } = fieldPattern()?.items

  const refErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_ref`]) 
  const amountErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_amount`]) 
  const currencyErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_currency`]) 
  const quantityErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_quantity`]) 
  const uomErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_uom`]) 


  return (
    <Grid.Row>
      <Grid.Column width='1' style={{textAlign:'center'}}>
          <CopyRepElement 
            title={`ADDITIONAL_DOCS`}
            request={{ documentCode, ref, amount, uom, currency, quantity }}
            callback={copyData}
            isFormDisabled={isFormdisabled}
          />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild border-bottom  b-rw-0'>
        <AddDropdown
          id={`doccode-${id}`}
          type='documentCode'
          isDisabled={isFormdisabled}
          label={translate('DOC_CODE')}
          onSelect={({ value }) => {
            updateData(id, { documentCode: value })
            saveData({ id, documentCode: value })
          }}
          onBlur={({ value }) => {
            if(!value?.trim()){
              updateData(id, { documentCode: value })
              saveData({ id, documentCode: value || " " })              
          }}}
          selectedValue={documentCode}
        />
      </Grid.Column>

      <Grid.Column width='2' className='divFormFeild  border-bottom  b-rw-0'>
        <InputField
          isDisabled={isFormdisabled}
          isLabel={false}
          id={`reference-${id}`}
          type='text'
          label={translate('REF')}
          value={ref}
          className='field-bg'
          errors={refErr && refErr?.msg}
          clearInput={false}
          onChange={(value) => updateData(id, { ref: value })}
          onBlur={(value) => {
            saveData({ id, ref: ref || ' ' })
            const key = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_ref`
            validateError({[key]:""},{[key]:value},
              {[key]:additionalDoc(invoiceIndex+1, lineItemIndex+1, addDocIdx+1)?.ref}
            )}
          }
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild   border-bottom b-rw-0'>
        <InputField
          isDisabled={isFormdisabled}
          id={`amount-${id}`}
          name='amount'
          type='number'
          label={translate('AMOUNT', { ns: ['default', 'header'] })}
          className='field-bg'
          errors={amountErr&&amountErr?.msg}
          isLabel={false}
          clearInput={false}
          value={amount}
          onChange={(value) =>updateData(id, { amount: value })}
          onBlur={(value) => {
            saveData({ id, amount: amount || ' ' })
            const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_amount`
            const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_currency`
            let repElemErr = validate({amount:value,currency:currency},
              {amount:additionalDoc()?.amount,
                currency:additionalDoc()?.currency}
            ) || {}
            repElemErr = createRepElemMsgStructure(repElemErr, "additionalDoc", invoiceIndex, lineItemIndex, addDocIdx)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName:'items',
              payload:{[key1]:"",[key2]:"",...repElemErr}
            })
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  border-bottom b-rw-0  '>
        <DropDown
          id={`currency-${id}`}
          isDisabled={isFormdisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          label={translate('CURRENCY')}
          boxNumber='44'
          errors={currencyErr&&currencyErr?.msg}
          isLabel={true}
          data={currencyList}
          value={currency}
          clearable
          onChange={(value) => {
            saveData({ id, currency: value })
            updateData(id, { currency: value?.trim() })
            const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_amount`
            const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_currency`
            let repElemErr = validate({amount:amount,currency:value},
              {amount:additionalDoc()?.amount,
                currency:additionalDoc()?.currency}
            ) || {}
            repElemErr = createRepElemMsgStructure(repElemErr, "additionalDoc", invoiceIndex, lineItemIndex, addDocIdx)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName:'items',
              payload:{[key1]:"",[key2]:"",...repElemErr}
            })
          }}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild  border-bottom b-rw-0  '>
        <InputField
          isDisabled={isFormdisabled}
          isLabel={false}
          id={`qty-${id}`}
          type='number'
          value={quantity}
          label={translate('QTY', { ns: ['default', 'header'] })}
          className='field-bg'
          errors={quantityErr && quantityErr?.msg}
          clearInput={false}
          onChange={(value) =>updateData(id, { quantity: value })}
          onBlur={(value) => {
            saveData({ id, quantity: quantity || ' ' })
            const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_quantity`
            const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_uom`
            let repElemErr = validate({quantity:value,uom:uom},
              {quantity:additionalDoc()?.quantity,
                uom:additionalDoc()?.uom}
            ) || {}
            repElemErr = createRepElemMsgStructure(repElemErr, "additionalDoc", invoiceIndex, lineItemIndex, addDocIdx)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName:'items',
              payload:{[key1]:"",[key2]:"",...repElemErr}
            })
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  border-bottom'>
        <DropDown
          id={`uom-${id}`}
          isDisabled={isFormdisabled}
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          label={translate('UOM')}
          boxNumber='44'
          isLabel={true}
          errors={uomErr&&uomErr?.msg}
          data={UomDropdownValue}
          value={uom}
          clearable
          onChange={(value) => {
            saveData({ id, uom: value })
            updateData(id, { uom: value?.trim() })
            const key1 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_quantity`
            const key2 = `invoice${invoiceIndex+1}_lineItem${lineItemIndex+1}_additionalDoc${addDocIdx+1}_uom`
            let repElemErr = validate({quantity:quantity,uom:value},
              {quantity:additionalDoc()?.quantity,
                uom:additionalDoc()?.uom}
            ) || {}
            repElemErr = createRepElemMsgStructure(repElemErr, "additionalDoc", invoiceIndex, lineItemIndex, addDocIdx)
            dispatch({
              type: ActionTypes.UPDATE_VALIDATION_ERRORS,
              tabName:'items',
              payload:{[key1]:"",[key2]:"",...repElemErr}
            })
          }}
        />
      </Grid.Column>
      <Grid.Column width='1' className='icon-delete-add-info'>
      <Icon disabled={isFormdisabled} name="trash alternate outline" id={`additional-docs-delete-${id}`}  onClick={() =>deleteData(id, initItemsTabValidation)} />
      
      </Grid.Column>
    </Grid.Row> 
  )
}

export default React.memo(AdditionalDocumentDetailsAGS)
